import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { searchBfLeads } from "@/lib/bf";

const label = (l) => [l.salon, l.admin_name, l.phone, l.cui && `CUI ${l.cui}`, l.city].filter(Boolean).join(" · ");

export default function BFLeadPick({ value, initial = [], onPick }) {
  const [q, setQ] = useState("");
  const [opts, setOpts] = useState(initial);
  const [chosen, setChosen] = useState(initial.find((l) => l.id === value) || null);
  useEffect(() => {
    if (q.trim().length < 2) return undefined;
    const t = setTimeout(() => searchBfLeads(q).then(setOpts).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  const pick = (l) => { setChosen(l); onPick(l); setQ(""); };
  if (chosen) {
    return (
      <div className="bf-lp-chosen" data-testid="bf-fo-lead-chosen">
        <span><b>{chosen.salon}</b><small>{label({ ...chosen, salon: "" })}</small></span>
        <button type="button" onClick={() => pick(null)} aria-label="Schimbă salonul" data-testid="bf-fo-lead-clear"><X size={14} /> Schimbă</button>
      </div>
    );
  }
  return (
    <div className="bf-lp" data-testid="bf-fo-lead-pick">
      <label className="bf-stock-search"><Search size={15} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută salonul: denumire, firmă, nume, telefon sau CUI" data-testid="bf-fo-lead-search" /></label>
      {opts.length > 0 && <ul>{opts.map((l) => <li key={l.id}><button type="button" onClick={() => pick(l)} data-testid={`bf-fo-lead-opt-${l.id}`}><b>{l.salon}</b> <small>{label({ ...l, salon: "" })}</small></button></li>)}</ul>}
      {q.trim().length >= 2 && !opts.length && <p className="st-hint">Niciun salon înscris găsit. Completează datele mai jos.</p>}
    </div>
  );
}
